var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value) }) }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) { try { step(generator.next(value)) } catch (e) { reject(e) } }
    function rejected(value) { try { step(generator["throw"](value)) } catch (e) { reject(e) } }
    function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected) }
    step((generator = generator.apply(thisArg, _arguments || [])).next())
  })
}
import Service from './service'
export var ApiPrintPhotoMessageType;
(function (ApiPrintPhotoMessageType) {
  ApiPrintPhotoMessageType["PRINT_PHOTO"] = "printer.photo.print"
  ApiPrintPhotoMessageType["PRINT_PHOTO_STATE"] = "printer.photo.state"
  ApiPrintPhotoMessageType["PRINT_PHOTO_FINISH"] = "printer.photo.finish"
  ApiPrintPhotoMessageType["PRINT_PHOTO_SUCCESS"] = "printer.photo.success"
  ApiPrintPhotoMessageType["PRINT_PHOTO_ERROR"] = "printer.photo.error"
  ApiPrintPhotoMessageType["PRINT_PHOTO_NO_PRINTER"] = "printer.photo.noprinter"
  ApiPrintPhotoMessageType["PRINT_PHOTO_STATE_INFO"] = "printer.photo.state.info"
})(ApiPrintPhotoMessageType || (ApiPrintPhotoMessageType = {}))
export var PrintPhotoMessageType;
(function (PrintPhotoMessageType) {
  PrintPhotoMessageType["PRINTER_PHOTO_SUCCESS"] = "PRINTER_PHOTO_SUCCESS"
  PrintPhotoMessageType["PRINTER_PHOTO_ERROR"] = "PRINTER_PHOTO_ERROR"
  PrintPhotoMessageType["PRINTER_PHOTO_INFO"] = "PRINTER_PHOTO_INFO"
  PrintPhotoMessageType["PRINTER_PHOTO_NO_PRINTER"] = "PRINTER_PHOTO_NO_PRINTER"
  PrintPhotoMessageType["PRINTER_PHOTO_FINISH"] = "PRINTER_PHOTO_FINISH"
})(PrintPhotoMessageType || (PrintPhotoMessageType = {}))
export var PhotoPrinterInfoStates;
(function (PhotoPrinterInfoStates) {
  PhotoPrinterInfoStates["NotConnected"] = "NOT_CONNECTED"
  PhotoPrinterInfoStates["IDLE"] = "IDLE"
  PhotoPrinterInfoStates["InProcess"] = "IN_PROCESS"
  PhotoPrinterInfoStates["Error"] = "ERROR"
})(PhotoPrinterInfoStates || (PhotoPrinterInfoStates = {}))
/**
 * Сервис для печати на фото принтере
 * @version 0.0.1
 * @since 2.0.0
 */
export default class PromobotPrintPhotoService extends Service {
  constructor(messageChannel) {
    super(messageChannel)
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiPrintPhotoMessageType.PRINT_PHOTO_FINISH:
          this.resolve(this.waiters.result)
          this.broadcast(PrintPhotoMessageType.PRINTER_PHOTO_FINISH)
          break
        case ApiPrintPhotoMessageType.PRINT_PHOTO_SUCCESS:
          this.broadcast(PrintPhotoMessageType.PRINTER_PHOTO_SUCCESS)
          break
        case ApiPrintPhotoMessageType.PRINT_PHOTO_STATE_INFO:
          this.resolve(this.waiters.status, message.state)
          this.broadcast(PrintPhotoMessageType.PRINTER_PHOTO_INFO, message)
          break
        case ApiPrintPhotoMessageType.PRINT_PHOTO_NO_PRINTER:
          this.broadcast(PrintPhotoMessageType.PRINTER_PHOTO_NO_PRINTER)
          this.reject(this.waiters.result, message.type)
          break
        case ApiPrintPhotoMessageType.PRINT_PHOTO_ERROR:
          this.broadcast(PrintPhotoMessageType.PRINTER_PHOTO_ERROR, message.type)
          this.reject(this.waiters.result, message.type)
          break
      }
    }
    this.waiters = {
      result: [],
      status: [],
    }
    const messageTypesForSubscribe = [
      ApiPrintPhotoMessageType.PRINT_PHOTO_FINISH,
      ApiPrintPhotoMessageType.PRINT_PHOTO_SUCCESS,
      ApiPrintPhotoMessageType.PRINT_PHOTO_STATE_INFO,
      ApiPrintPhotoMessageType.PRINT_PHOTO_ERROR,
      ApiPrintPhotoMessageType.PRINT_PHOTO_NO_PRINTER,
    ]
    messageTypesForSubscribe.forEach(messageType => {
      this.messageChannel.subscribe(messageType, messageHandler)
    })
  }
  /**
     * Напечатать фотографию
     *
     * Во время печати может быть брошена ошибка, но это не означает, что не удалось напечатать.
     * Возможно была сброшена внутренняя (C++) ошибка.
     * Поэтому при ошибке необходимо опросить статус принтера.
     *
     * @since 2.0.0
     * @param {string} data - полный путь к файлу или изображение в формате base64
     * @return {*}  {Promise<void>}
     * @memberof PromobotPrintPhotoService
     *
     * @example <caption>Напечатать фото</caption>
     * await robot.printPhotoService.print(data)
     *  .catch(async () => {
     *    const status = await robot.printPhotoService.status()
     *    if (status === PhotoPrinterInfoStates.Error) {
     *      doSomethingWithError()
     *      ...
     *    }
     *    ...
     *  })
     */
  print(data) {
    return __awaiter(this, void 0, void 0, function* () {
      if (data.startsWith('data:image/png;base64')) {
        return this.printByData(data, null)
      }
      else {
        return this.printByData(null, data)
      }
    })
  }
  printByData(data = null, filename = null) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.execute({
        type: ApiPrintPhotoMessageType.PRINT_PHOTO,
        filename,
        data,
        ignoreNotConnected: true,
      }, this.waiters.result)
    })
  }
  /**
     * Получить статус фотопринтера
     *
     * @since 2.0.0
     * @return {*}  {Promise<PhotoPrinterInfoStates>}
     * @memberof PromobotPrintPhotoService
     *
     * @example <caption>Получить статус фотопринтера</caption>
     * robot.printPhotoService.status()
     */
  status() {
    return __awaiter(this, void 0, void 0, function* () {
      return this.execute({
        type: ApiPrintPhotoMessageType.PRINT_PHOTO_STATE,
        ignoreNotConnected: true,
      }, this.waiters.status)
    })
  }
  /**
     * Очистить очередь печати фотопринтера
     *
     * @since 2.0.0
     * @memberof PromobotPrintPhotoService
     *
     * @example <caption>Очистить очередь печати фотопринтера</caption>
     * robot.printPhotoService.clearQueue()
     */
  clearQueue() {
    this.messageChannel.send({
      type: ApiPrintPhotoMessageType.PRINT_PHOTO,
      clear: null,
    })
  }
  /**
     * Фотография успешно отправлена на печать
     *
     * @since 2.0.0
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof PromobotPrintPhotoService
     *
     * @example <caption>Фотография успешно отправлена на печать</caption>
     * robot.printPhotoService.onSuccess(() => {
     *   ...
     * })
     */
  onSuccess(callback) {
    return this.subscribe(PrintPhotoMessageType.PRINTER_PHOTO_SUCCESS, callback)
  }
  /**
     * Фотография успешно распечатана
     *
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof PromobotPrintPhotoService
     */
  onFinish(callback) {
    return this.subscribe(PrintPhotoMessageType.PRINTER_PHOTO_FINISH, callback)
  }
  /**
     * Внутреннее (C++) состояние ошибки изменилось
     *
     * @since 2.0.0
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof PromobotPrintPhotoService
     *
     * @example <caption>Произошла ошибка</caption>
     * robot.printPhotoService.onError(async () => {
     *    const status = await robot.printPhotoService.status()
     *    if (status === PhotoPrinterInfoStates.Error) {
     *      doSomethingWithError()
     *      ...
     *    }
     * })
     *
     * @example <caption>Состояние ошибки было сброшено</caption>
     * robot.printPhotoService.onError(async () => {
     *    const status = await robot.printPhotoService.status()
     *    if (status !== PhotoPrinterInfoStates.Error) {
     *      doSomething()
     *      ...
     *    }
     * })
     */
  onError(callback) {
    return this.subscribe(PrintPhotoMessageType.PRINTER_PHOTO_ERROR, callback)
  }
  /**
     * Сервис вернул данные о состоянии фотопринтера
     *
     * @since 2.0.0
     * @param {((info: PhotoPrinterInfoError | { state: Exclude<PhotoPrinterInfoStates, PhotoPrinterInfoStates.Error> }) => void)} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof PromobotPrintPhotoService
     *
     * @example <caption>Сервис вернул данные о состоянии фотопринтера</caption>
     * robot.printPhotoService.onInfo((state) => {
     *   ...
     * })
     */
  onInfo(callback) {
    return this.subscribe(PrintPhotoMessageType.PRINTER_PHOTO_INFO, callback)
  }
  /**
     * Фотопринтер отсутствует
     *
     * @since 2.0.0
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof PromobotPrintPhotoService
     *
     * @example <caption>Фотопринтер отсутствует</caption>
     * robot.printPhotoService.onNoPrinter(() => {
     *   ...
     * })
     */
  onNoPrinter(callback) {
    return this.subscribe(PrintPhotoMessageType.PRINTER_PHOTO_NO_PRINTER, callback)
  }
}
